import React, {useState} from "react";
import {Button} from "@syscocorporation/cx-foundation-react";
import ModalComponent from "../../components/Modal";
import data from "../../../data.json";
import "./style.css";
import {checkDocUploadStatus, CoraRedirection} from "../../../utils/HomeApis";
import {useDispatch} from "react-redux";
import {Snackbar} from "../Snackbar/redux/snackbarSlice";

function CertificationCompletedPopUp({homeData}) {
    const dispatch = useDispatch();
    const [redirect, setRedirect] = useState(false);
    const handleContinueButtonClick = async () => {
        const status = await checkDocUploadStatus(homeData);
        if (status?.data?.uploaded) {
            setRedirect(true);
            CoraRedirection({status: "Awaiting", homeData, dispatch});
        } else {
            setRedirect(true);
            dispatch(
                Snackbar({
                    message:
                        "Certificate is not uploaded. Please try again later!",
                    severity: "error",
                })
            );
            CoraRedirection({status: "Taxable", homeData, dispatch});
        }
    };

    return (
        <div className="redirectModal">
            {!redirect && (
                <ModalComponent title={data.certificationCompletedHeading}>
                    <div className="con-btn">

                        <Button onClick={handleContinueButtonClick}>
                            {data.continueButton}
                        </Button>

                    </div>
                </ModalComponent>
            )}
        </div>
    );
}

export default CertificationCompletedPopUp;
